import { SessionType } from '../adyen/session-types';

export function resolveSessionTypeFromPath(): SessionType {
    const path = window.location.pathname;

    if (path.endsWith('/tokenization-session')) {
        return SessionType.TOKENIZATION;
    }

    return SessionType.PAYMENT;
}
